import { render, staticRenderFns } from "./PB-Signature.vue?vue&type=template&id=02a07b7b&scoped=true&"
import script from "./PB-Signature.vue?vue&type=script&lang=js&"
export * from "./PB-Signature.vue?vue&type=script&lang=js&"
import style0 from "./PB-Signature.vue?vue&type=style&index=0&id=02a07b7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a07b7b",
  null
  
)

export default component.exports